var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 24.9707C44.5 14.4773 35.9934 5.9707 25.5 5.9707C15.0066 5.9707 6.5 14.4773 6.5 24.9707C6.5 35.4641 15.0066 43.9707 25.5 43.9707C35.9934 43.9707 44.5 35.4641 44.5 24.9707ZM45.5 24.9707C45.5 13.925 36.5456 4.9707 25.5 4.9707C14.4543 4.9707 5.5 13.925 5.5 24.9707C5.5 36.0163 14.4543 44.9707 25.5 44.9707C36.5456 44.9707 45.5 36.0163 45.5 24.9707Z",
    fill: "#FF9C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3357 19.4081C29.5949 19.1361 30.0153 19.1361 30.2745 19.4081L33.5939 22.8911C33.8531 23.1631 33.8531 23.6043 33.5939 23.8763L30.2745 27.3593C30.0153 27.6313 29.5949 27.6313 29.3357 27.3593C29.0763 27.0871 29.0763 26.6461 29.3357 26.3741L31.5217 24.0803H24.1337L24.1333 23.3837L24.1337 22.6871H31.5217L29.3357 20.3933C29.0763 20.1212 29.0763 19.6802 29.3357 19.4081Z",
    fill: "#050505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6845 31.539C20.4253 31.811 20.0049 31.811 19.7457 31.539L16.4264 28.056C16.1671 27.784 16.1671 27.343 16.4264 27.0708L19.7457 23.5878C20.005 23.3158 20.4253 23.3158 20.6845 23.5878C20.9438 23.86 20.9438 24.301 20.6845 24.573L18.4985 26.8668H25.8864L25.8868 27.5634L25.8864 28.26H18.4985L20.6845 30.5538C20.9438 30.8258 20.9438 31.267 20.6845 31.539Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingSwitch);
export default __webpack_public_path__ + "react/media/billing-switch.5d0af8bd193fce4ce2801000ce9f51a3.svg";
export { ForwardRef as ReactComponent };